<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default{
  name: 'App'
}
</script>

<style>
html{
  height: 100%;
  background: #eee
}
</style>

